interface TopicCard {
  title: string;
  tag: string;
  desc: string;
  imageUrl: string;
  imageAlt: string;
}

const topics: TopicCard[] = [
  {
    title: '动作冒险大片',
    tag: '热血激燃',
    desc: '肾上腺素飙升的动作巨制合集，硬汉对决、极限追逐、枪战爆炸一次看过瘾',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20intense%20explosions%20and%20dramatic%20car%20chase%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20lighting%20with%20flares%2C%20dust%20and%20debris%20in%20the%20air%2C%20blockbuster%20film%20aesthetic%2C%20high%20contrast%2C%20professional%20movie%20still%20photography&width=600&height=400&seq=index-action-wuma&orientation=landscape',
    imageAlt: '动作冒险大片专题',
  },
  {
    title: '科幻巨制殿堂',
    tag: '想象无限',
    desc: '探索未来世界与浩瀚宇宙，顶尖视效科幻电影全集，满足你对未知的无限想象',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20spaceships%20and%20neon%20lights%2C%20deep%20space%20backdrop%20with%20stars%2C%20sleek%20technology%20and%20holographic%20displays%2C%20warm%20golden%20and%20teal%20accent%20colors%2C%20cinematic%20composition%2C%20epic%20scope%2C%20professional%20movie%20still&width=600&height=400&seq=index-scifi-wuma&orientation=landscape',
    imageAlt: '科幻巨制殿堂专题',
  },
  {
    title: '爆笑喜剧合集',
    tag: '欢乐无限',
    desc: '精选国内外高分喜剧电影，工作学习之余来一部，笑到停不下来的快乐时光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20comedy%20movie%20scene%20with%20warm%20sunlight%2C%20friends%20laughing%20together%20in%20a%20cozy%20living%20room%20setting%2C%20colorful%20decor%2C%20feel-good%20atmosphere%2C%20golden%20hour%20lighting%2C%20soft%20and%20natural%20photography%2C%20cinematic%20warm%20tones&width=600&height=400&seq=index-comedy-wuma&orientation=landscape',
    imageAlt: '爆笑喜剧合集专题',
  },
  {
    title: '悬疑惊悚剧场',
    tag: '烧脑反转',
    desc: '高分悬疑片与惊悚经典，层层反转、细思极恐，挑战你的推理极限与心理承受力',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20movie%20scene%20with%20dim%20lighting%20and%20long%20shadows%2C%20foggy%20alleyway%20at%20night%2C%20noir%20cinematography%2C%20dramatic%20contrast%20between%20light%20and%20dark%2C%20moody%20atmosphere%2C%20professional%20film%20still%20with%20rich%20textures&width=600&height=400&seq=index-thriller-wuma&orientation=landscape',
    imageAlt: '悬疑惊悚剧场专题',
  },
  {
    title: '动画电影世界',
    tag: '全家共享',
    desc: '迪士尼、皮克斯、吉卜力等顶级动画电影全集，治愈画风与动人故事适合全年龄段',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20animated%20film%20scene%20with%20vibrant%20colors%20and%20magical%20atmosphere%2C%20hand-drawn%20aesthetic%20with%20soft%20warm%20lighting%2C%20whimsical%20landscape%20with%20floating%20elements%2C%20heartwarming%20visual%20style%2C%20professional%20animation%20art%2C%20rich%20color%20palette&width=600&height=400&seq=index-animation-wuma&orientation=landscape',
    imageAlt: '动画电影世界专题',
  },
  {
    title: '经典怀旧影厅',
    tag: '时光重现',
    desc: '豆瓣高分经典老片重温，从黑白胶片到千禧年佳作，每一帧都是不可错过的光影记忆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20movie%20scene%20with%20old%20film%20grain%20texture%2C%20warm%20sepia%20tones%2C%20nostalgic%20black%20and%20white%20cinematography%2C%20retro%20cinema%20aesthetic%2C%20elegant%20composition%2C%20timeless%20Hollywood%20glamour%2C%20soft%20focus%20photography&width=600&height=400&seq=index-classic-wuma&orientation=landscape',
    imageAlt: '经典怀旧影厅专题',
  },
  {
    title: '纪录片精选集',
    tag: '真实力量',
    desc: '自然、历史、科技、人文高分纪录片精选，用镜头探索真实世界的无限精彩与震撼',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20majestic%20mountains%20and%20golden%20sunlight%2C%20aerial%20cinematography%2C%20rich%20earth%20tones%20and%20natural%20colors%2C%20breathtaking%20landscape%2C%20professional%20wildlife%20photography%2C%20warm%20and%20organic%20aesthetic&width=600&height=400&seq=index-doc-wuma&orientation=landscape',
    imageAlt: '纪录片精选集专题',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              精选专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              按类型精心编排的电影专题合集，快速发现你心仪的影片类型
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
            {topics.map((item, idx) => (
              <a
                key={idx}
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-44 md:h-48 overflow-hidden bg-background-200">
                  <img
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}